import searchIcon from '../assets/images/icons/search.png'
import eraseIcon from '../assets/images/icons/erase.png'

const inputStyle = {
  height: 24,
  borderRadius: 6,
  border: '1px solid #107c6b',
  padding: '0 10px',
  outline: 'none',
  minWidth: 180,
  marginTop: 5
}

const GenericSearchToggle = ({
  visible,
  query,
  onToggle,
  onQueryChange,
  placeholder = 'Hľadať...'
}) => {

  const hasText = query.trim() !== ''

  const activeGlow =
    '0 2px 18px rgba(16,124,107,0.65), 0 0 6px rgba(16,124,107,0.55)'
  const normalShadow =
    '0 1px 8px rgba(0,0,0,0.30)'

  const background =
    hasText ? '#d9ffe4'
    : visible ? '#2da9a4'
    : '#f5f5f5'

  const shadow =
    hasText ? activeGlow : normalShadow

  const handleClick = () => {
    if (hasText) {
      onQueryChange('')
      return
    }
    onToggle()
  }

  return (
    <>
      {visible && (
        <input
          type="text"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder={placeholder}
          style={inputStyle}
        />
      )}

      <button
        type="button"
        onClick={handleClick}
        style={{
          border: '1.5px solid #107c6b',
          background: background,
          borderRadius: 6,
          height: 24,
          width: 36,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: shadow,
          transition: 'transform 0.05s ease, box-shadow 0.1s ease',
          marginTop: 5,
          outline: 'none'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#2da9a4'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = background
          e.currentTarget.style.transform = 'scale(1)'
          e.currentTarget.style.boxShadow = shadow
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = 'scale(0.96)'
          e.currentTarget.style.boxShadow = '0 0px 4px rgba(0,0,0,0.25)'
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = 'scale(1)'
          e.currentTarget.style.boxShadow = shadow
        }}
      >
        <img
          src={hasText ? eraseIcon : searchIcon}
          alt="search"
          style={{ width: 18, height: 18 }}
        />
      </button>
    </>
  )
}

export default GenericSearchToggle